import Dropdown from 'react-bootstrap/Dropdown'
import "react-dropdown/style.css";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import { useEffect, useState } from "react";
import { showDangerToast } from "../../constants/toaster";
import { s3 } from "../../constants/awsConfig";
import { useDispatch, useSelector } from "react-redux";
import { updateLoading } from "../../../redux/features/common/commonSlice";
import urls from "../../constants/apiurl";
import ApiCaller from "../../constants/ApiCaller";
import { FormControlLabel, Radio, RadioGroup } from '@mui/material';

export const Add = (props) => {
    const dispatch = useDispatch()
    const [imageFile, setImageFile] = useState(null);
    const [image, setImage] = useState(null);
    const userData = useSelector(state => state?.userData)
    const [categoryDropdownDataList, setCategoryDropdownDataList] = useState([])
    const [typeDropdownText, setTypeDropdownText] = useState({
        id: null,
        value: 'Select Parent'
    })

    useEffect(() => {
        if (props?.show) {
            console.log(props?.paymentGatewayFormData)
            getCategoryList()
        }
    }, [props.show]);

    const uploadFileToAWS = async (selectedFile) => {
        if (!selectedFile) return;

        const params = {
            Bucket: 'supa-dev-bucket', // bucket name
            Key: `uploads/${selectedFile.name}`,
            Body: selectedFile,
            ContentType: selectedFile.type,
            // ACL: 'public-read', // Adjust according to your needs
        };

        try {
            const data = await s3.upload(params).promise();
            const url = data.Location.replace(
                "https://supa-dev-bucket.s3.af-south-1.amazonaws.com/",
                "https://d2up68x544gew2.cloudfront.net/"
            );
            return { success: true, url: url }
        } catch (error) {
            console.error('Error uploading file:', error);
            return { success: false }
        }
    };

    const getCategoryList = async () => {
        try {
            dispatch(updateLoading(true))
            let path = urls.paymentGatewayKeyValuePair
            let res = await ApiCaller.get({}, path, userData?.access_token)
            const response = await res.response.json()
            if (response.status == 200) {
                dispatch(updateLoading(false))
                console.log(response?.data)
                let tempArray = [{
                    id: null,
                    value: 'Select Parent'
                }]
                for (let i = 0; i < response?.data?.length; i++) {
                    tempArray.push({
                        id: response?.data?.[i]?.key,
                        value: response?.data?.[i]?.value
                    })
                    if (props?.paymentGatewayFormData?.parentId === response?.data[i]?.key) {
                        setTypeDropdownText({
                            id: response?.data?.[i]?.key,
                            value: response?.data?.[i]?.value
                        })
                    }
                }
                setCategoryDropdownDataList(tempArray)
            } else {
                dispatch(updateLoading(false))
                showDangerToast(response.message)
            }
        } catch (error) {
            dispatch(updateLoading(false))
            console.error(error)
            showDangerToast(error.message)
        }
    }

    const handleSubmit = async () => {
        let validateSuccess = false;
        if (props?.paymentGatewayFormData?.id) {
            if (
                props?.paymentGatewayFormData?.name &&
                props?.paymentGatewayFormData?.slug &&
                props?.paymentGatewayFormData?.icon
            ) {
                validateSuccess = true;
                if (validateSuccess) {
                    if (imageFile) {
                        dispatch(updateLoading(true));
                        const isImageUploaded = await uploadFileToAWS(imageFile);
                        dispatch(updateLoading(false));
                        if (isImageUploaded.success) {
                            props.onSubmit(isImageUploaded.url);
                        } else {
                            showDangerToast("Image upload failed.");
                        }
                    } else {
                        props.onSubmit(props?.paymentGatewayFormData?.icon);
                    }
                }
            } else {
                showDangerToast("Please fill all required Fields.");
            }
        } else {
            if (
                props?.paymentGatewayFormData?.name &&
                props?.paymentGatewayFormData?.slug &&
                props?.paymentGatewayFormData?.icon &&
                imageFile
            ) {
                validateSuccess = true;
            } else {
                showDangerToast("Please fill all required Fields.");
                validateSuccess = false;
            }
            if (validateSuccess) {
                dispatch(updateLoading(true));
                const isImageUploaded = await uploadFileToAWS(imageFile);
                dispatch(updateLoading(false));
                if (isImageUploaded.success) {
                    props.onSubmit(isImageUploaded.url);
                    console.log(isImageUploaded.url)
                } else {
                    showDangerToast("Image upload failed.");
                }
            }
        }
    }

    const handleImageChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setImageFile(file);
            // props?.setPaymentGatewayFormData({
            //     ...props?.paymentGatewayFormData,
            //     thumbnail: ''
            // })
            setImage(URL.createObjectURL(file));
        }
    };

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header>
                <Modal.Title id="contained-modal-title-vcenter">
                    {props?.paymentGatewayFormData?.id ? "Update Payment Gateway" : "Add Gateway"}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row">
                    <div className="col-md-6">
                        <Form.Group controlId='exampleForm.ControlInput1'>
                            <div style={{ display: 'grid' }}>
                                <Form.Label>Slug</Form.Label>
                                <Form.Control
                                    value={props.paymentGatewayFormData?.slug}
                                    onChange={(e) =>
                                        props.setPaymentGatewayFormData({
                                            ...props?.paymentGatewayFormData,
                                            slug: e.target.value,
                                        })
                                    }
                                    placeholder="Slug"
                                    aria-label="Small"
                                    aria-describedby="inputGroup-sizing-sm"
                                />
                            </div>
                        </Form.Group>
                    </div>
                    <div className="col-md-6">
                        <Form.Group controlId='exampleForm.ControlInput1'>
                            <div style={{ display: 'grid' }}>
                                <Form.Label>Title</Form.Label>
                                <Form.Control
                                    value={props.paymentGatewayFormData?.name}
                                    onChange={(e) =>
                                        props.setPaymentGatewayFormData({
                                            ...props?.paymentGatewayFormData,
                                            name: e.target.value,
                                        })
                                    }
                                    placeholder="Name"
                                    aria-label="Small"
                                    aria-describedby="inputGroup-sizing-sm"
                                />
                            </div>
                        </Form.Group>
                    </div>
                    <div className="col-md-6">
                        <Form.Group controlId='exampleForm.ControlInput1'>
                            <div style={{ display: 'grid' }}>
                                <Form.Label>Select Parent</Form.Label>
                                <Dropdown>
                                    <Dropdown.Toggle
                                        variant='success'
                                        style={{
                                            backgroundColor: 'white',
                                            color: 'black',
                                            border: '1px solid #cad1d7',
                                            boxShadow: 'none',
                                            transform: 'none'
                                        }}
                                        id='dropdown-basic'
                                    >
                                        {typeDropdownText?.value}
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        {categoryDropdownDataList?.map((data, i) => {
                                            return <>
                                                <Dropdown.Item
                                                    onClick={() => {
                                                        setTypeDropdownText(data)
                                                        props.setPaymentGatewayFormData({
                                                            ...props?.paymentGatewayFormData,
                                                            parentId: data?.id,
                                                        })
                                                    }
                                                    }
                                                >
                                                    {data?.value}
                                                </Dropdown.Item>
                                            </>
                                        })}
                                    </Dropdown.Menu>
                                </Dropdown>
                            </div>
                        </Form.Group>

                    </div>
                    <div className='col-md-6 mt-2'>
                        <Form.Group controlId='exampleForm.ControlInput1'>
                            <div style={{ display: 'grid' }}>
                                <Form.Label>Choose Icon</Form.Label>
                                <input type="file" accept="image/*" onChange={handleImageChange} />
                            </div>
                        </Form.Group>
                        <div>
                            {props?.paymentGatewayFormData?.thumbnail ? <img src={props?.paymentGatewayFormData?.thumbnail} style={{ maxWidth: "200px", maxHeight: '200px', marginTop: "10px" }}></img> : <img src={image} style={{ maxWidth: "200px", maxHeight: '200px', marginTop: "10px" }}></img>}
                        </div>

                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="outlined" onClick={props.onHide}>
                    Cancel
                </Button>
                <Button onClick={handleSubmit}>Submit</Button>
            </Modal.Footer>
        </Modal>
    );
};
